import PropTypes from "prop-types";

import AtAGlance from "./AtAGlance";
import Updates from "./Updates";
import { IMPLEMENTATION_GUIDE_URL, QUICK_START_GUIDE_URL } from "../header/ResourcesLinks.jsx";

import "../../styles/SchoolHome.scss";
import "../../styles/Updates.scss";

/**
 * This is the School Home page for school admin epr
 * @name SchoolHome
 * @returns {JSX.Element}
 */
const SchoolHome = ({ applicableGrades, combinedGrades, loader, status, statusClass, timePeriodDto }) => {
    return (
        <div className="school-home-wrapper">
            <div className="home-top-row">
                <Updates loader={loader} status={status} statusClass={statusClass} timePeriodDto={timePeriodDto} />
                <section className="school-section-container home-resources">
                    <div className="sub-section-title">Resources</div>
                    <div className="sub-section-line" />
                    <div className="school-updates-container">
                        <div className="updates-text">
                            Use these guides to get started with Report Card this semester.
                        </div>
                        <a
                            className="home-resource-link"
                            href={IMPLEMENTATION_GUIDE_URL}
                            rel="noreferrer"
                            target="_blank"
                        >
                            <i className="bi bi-journal-text" aria-hidden="true" /> Implementation Guide
                        </a>
                        <a className="home-resource-link" href={QUICK_START_GUIDE_URL} rel="noreferrer" target="_blank">
                            <i className="bi bi-lightning-charge" aria-hidden="true" /> Quick Start Guide
                        </a>
                    </div>
                </section>
            </div>
            <AtAGlance
                applicableGrades={applicableGrades}
                combinedGrades={combinedGrades}
                loader={loader}
                statusClass={statusClass}
            />
        </div>
    );
};

SchoolHome.propTypes = {
    applicableGrades: PropTypes.instanceOf(Array),
    combinedGrades: PropTypes.instanceOf(Array),
    loader: PropTypes.bool,
    status: PropTypes.string,
    statusClass: PropTypes.string,
    timePeriodDto: PropTypes.instanceOf(Array)
};

export default SchoolHome;
